<template>
  <div class="analyze-item">
    <div class="analyze-header">
      <div class="left">
        <div class="title">
          <em>第 {{ index }} 题：</em>
          {{ data.title }}
        </div>
      </div>
      <div class="type">{{ data.type | questionTypeCN }}</div>
    </div>
    <div class="stat">总答题人数：{{ data.total }}, 本题答题人数：{{ data.answer }}，占比 {{ data.total > 0 ? round(data.answer / data.total * 100, 2) : 0 }}%</div>

    <el-table :data="rows" style="width: 100%" :header-cell-style="tableStyle">
      <el-table-column type="index" align="center" width="50"></el-table-column>
      <el-table-column prop="title" label="选项" align="left"></el-table-column>
      <el-table-column prop="total" label="答题人数" align="center" width="120"></el-table-column>
      <el-table-column prop="select" label="选择人数" align="center" width="120"></el-table-column>
      <el-table-column label="比例" align="center" width="120">
        <template
          #default="{ row }"
        >{{ row.total > 0 ? round(row.select / row.total * 100, 2) : 0 }}%</template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object
    },
    index: {
      type: Number,
      default: 0
    }
  },
  computed: {
    rows() {
      return Object.values(this.data.options);
    }
  },
  data() {
    return {
      tableStyle: {
        color: "#6F6F6F",
        "background-color": "#F5F7F9",
        "border-color": "#E3E8EE"
      }
    };
  },
  methods: {
    round(number, precision) {
      return Math.round(+number + 'e' + precision) / Math.pow(10, precision);
    }

  }
};
</script>

<style lang="less" scoped>
.analyze-item {
  margin-bottom: 20px;

  .analyze-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .left {
      display: flex;
    }
    .type {
      width: 90px;
      text-align: center;
    }
  }

  .stat {
    margin: 10px 0;
    font-size: 12px;
    color: gray;
  }

  .title {
    em {
      font-style: normal;
      color: #1d82fc;
    }
  }

  .type {
    display: inline-block;
    font-size: 14px;
    color: #1d82fc;
    border: 1px solid #1d82fc;
    padding: 0 12px;
    margin-left: 18px;
  }

  .el-table {
    .el-table__body tr:hover > td {
      background-color: #ebf7ff !important;
    }
  }
}
</style>